import router from '../../shared/router';
import MenuService from '../../core/components/sidebar/MenuService';
import MenuItem from '../../core/components/sidebar/MenuItem';
import SunModel from './SunModel';

const {routes} = router.options;
const route = routes.find(r => r.path === '/app');

const tmpRoutes = [
  {
    path: 'sunmodel',
    name: 'SunModel',
    component: SunModel,
    meta: {
      requiresAuth: true,
    },
  },
];

tmpRoutes.forEach((obj) => {
  route.children.push(obj);
});

router.addRoutes([route]);
// MenuService.addItem(new MenuItem('graph', {
//   path: '/app/sunmodel',
//   text: 'Sun Model',
//   uuid: 'Sun Model',
//   permission: 'read',
//   weight: 0,
//   icon: ['fas', 'bezier-curve']
// }));
